type WindowWithDataLayer = Window & {
    dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM;

export const pageView = (url: string) => {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
            event: 'pageView',
            page: url,
        });
    }
};

export const downloadEvent = (stockItemId: number) => {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
            event: 'StockBlocks Event',
            eventCategory: 'Stock Item',
            eventAction: 'item_download',
            eventValue: stockItemId,
            eventLabel: window.location.pathname,
            stockItemId: stockItemId,
        });
    }
};
